
import React, { useEffect, useState } from "react";
import PedidoVendaService from "../../../../services/service.pedido";
import {
  Alert,
} from "react-bootstrap";
import T from "../../../../common/traducao";
import { Box, Divider, Grid, LinearProgress, Typography } from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PrintIcon from "@mui/icons-material/Print";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { SituacaoPedido } from "../../../../consts/situacao_pedido";

export default function ImprimirPedido({ id, situacao }) {
  const constantes = T();

  const [listaRelatoriosCliente, setListaRelatoriosCliente] = useState(
    []
  );
  const [listaRelatoriosVendedor, setListaRelatoriosVendedor] = useState(
    []
  );
  const [loading, setLoading] = useState(false);
  const [erroImpressao, setErroImpressao] = useState();
  const [openCollapseClientes, setOpenCollapseClientes] = React.useState(true);
  const [openCollapseVendedores, setOpenCollapseVendedores] = React.useState(true);
  const navigate = useNavigate()
  const handleCollapseClientes = () => {
    setOpenCollapseClientes(!openCollapseClientes)
  }

  const handleCollapseVendedores = () => {
    setOpenCollapseVendedores(!openCollapseVendedores)
  }
  
  async function GetRelatorios() {
    await PedidoVendaService.GetListaRelatoriosCustomizados(id)
      .then((response) => {
        setListaRelatoriosCliente(response.data.ImpressoesCliente);
        setListaRelatoriosVendedor(response.data.ImpressoesVendedor);
      })
      .catch((error) => {
        const _error =
          error.code === "ERR_NETWORK"
            ? "Server OffLine"
            : error.response && error.response.data && error.response.data.error
            ? error.response.data.error.message
            : error.message;
        setErroImpressao(_error);
        toast.error(error.message)
        navigate("/pedidosvenda")
      })
      .finally(() => {});
  }

  async function ImprimirSaldoPendencia() {
    setLoading(true);
    await PedidoVendaService.ImprimirSaldoPendenciaPedidoVenda(id)
      .then((response) => {
        try {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
          setLoading(false);
        } catch (error) {
          navigate("/pedidosvenda");
          toast.error("Ocorreu um erro ao tentar abrir o arquivo. Por favor, tente novamente mais tarde.");
        }
      })
      .catch((error) => {
        const _error =
          error.code === "ERR_NETWORK"
            ? "Server OffLine"
            : error.response && error.response.data && error.response.data.error
            ? error.response.data.error.message
            : error.message;
        setErroImpressao(_error);
        toast.error(error.message);
        navigate("/pedidosvenda");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function ImprimirRelatorio(link) {
    //window.open(`${process.env.REACT_APP_BASE_URL}${link}`);

    setLoading(true);
    await PedidoVendaService.ImprimirRelatorio(link)
      .then((response) => {
        try {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
          setLoading(false);
      } catch (error) {
          navigate("/pedidosvenda")
          toast.error("Ocorreu um erro ao tentar abrir o arquivo. Por favor, tente novamente mais tarde.");
      }
      })
      .catch((error) => {
        const _error =
          error.code === "ERR_NETWORK"
            ? "Server OffLine"
            : error.response && error.response.data && error.response.data.error
            ? error.response.data.error.message
            : error.message;
        setErroImpressao(error);
        toast.error(error.message)
        navigate("/pedidosvenda")
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    GetRelatorios();
  }, []);

  function ListagemRelatorios() {
    const alertClicked = (link) => {
      ImprimirRelatorio(link);
    };

    return (
      <>
        <Grid container display={"flex"} flexDirection={"column"} gap={1}>
          <Grid item sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PrintIcon  sx={{color: "#5e5e5e", flexShrink: 0}} />
            <Typography
              sx={{
                color: "#5e5e5e",
                fontSize: { xs: "16px", sm: "22px" },
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >{`${constantes.ImpressaoPedido} ${id}`}</Typography>
          </Grid>
          <Divider sx={{color: "black", background:"black"}} />
          <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", width: "100%", minWidth: 0 }}>
            <List
              sx={{
                width: "100%",
                maxWidth: "100%",
                bgcolor: "background.paper",
              }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListItemButton onClick={handleCollapseClientes}>
                <ListItemIcon>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemText sx={{color: "#595959", fontWeight: "bold"}} primary={constantes.Clientes}/>
                {openCollapseClientes ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openCollapseClientes} timeout="auto" unmountOnExit>
                {listaRelatoriosCliente &&
                  listaRelatoriosCliente.map((item, index) => {
                    return (
                      <>
                        <ListItemButton
                          disabled={loading}
                          key={index}
                          sx={{ pl: 4 }}
                          onClick={() => alertClicked(item.LinkDownload)}
                        >
                          <ListItemIcon>
                            <TextSnippetIcon />
                          </ListItemIcon>
                          <ListItemText primary={item.Descricao} />
                        </ListItemButton>
                      </>
                    );
                  })}
              </Collapse>

              <ListItemButton onClick={handleCollapseVendedores}>
                <ListItemIcon>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemText sx={{color: "#595959", fontWeight: "bold"}} primary={constantes.Vendedor}/>
                {openCollapseVendedores ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse in={openCollapseVendedores} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {listaRelatoriosVendedor &&
                    listaRelatoriosVendedor.map((item, index) => {
                      return (
                        <>
                          <ListItemButton
                            disabled={loading}
                            key={index}
                            sx={{ pl: 4 }}
                            onClick={() => alertClicked(item.LinkDownload)}
                          >
                            <ListItemIcon>
                              <TextSnippetIcon />
                            </ListItemIcon>
                            <ListItemText primary={item.Descricao} />
                          </ListItemButton>
                        </>
                      );
                    })}
                </List>
              </Collapse>

              {situacao === SituacaoPedido.PENDENTE && (
                <ListItemButton
                  disabled={loading}
                  onClick={() => ImprimirSaldoPendencia()}
                >
                  <ListItemIcon>
                    <InboxIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#595959" }} primary={constantes.SaldoEPendencia || "Saldo e Pendência"} />
                </ListItemButton>
              )}
            </List>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      {ListagemRelatorios()}

      {loading && (
        <Box sx={{display: "flex", flexDirection:"column",gap: 1, fontSize: "15px",}}>
          <Typography sx={{fontWeight: "bold", color: "#707070"}}>{constantes.MsgAguardeImprimirPedido}</Typography>
          <LinearProgress color="inherit"  />
        </Box>
      )}

      {erroImpressao && <Alert variant="danger">{erroImpressao}</Alert>}
    </>
  );
}

